import { render, staticRenderFns } from "./no-results-message-extras.vue?vue&type=template&id=9bb404b6&scoped=true"
import script from "./no-results-message-extras.vue?vue&type=script&setup=true&lang=ts"
export * from "./no-results-message-extras.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./no-results-message-extras.vue?vue&type=style&index=0&id=9bb404b6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb404b6",
  null
  
)

export default component.exports